import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import srcFieldConfigurationSchemesQuery from '@atlassian/jira-relay/src/__generated__/srcFieldConfigurationSchemesQuery.graphql.ts';
import type { EntryPointRouteParams } from '@atlassian/jira-entry-points-plugin/src/common/types.tsx';

export const globalAdminFieldConfigurationSchemesEntryPoint = createEntryPoint({
	root: JSResourceForUserVisible(
		() =>
			import(
				/* webpackChunkName: "async-jira-admin-pages-field-configuration-schemes" */ './src/index.tsx'
			),
	),
	getPreloadProps: ({ tenantContext }: EntryPointRouteParams) => ({
		queries: {
			pageQueryRef: {
				parameters: srcFieldConfigurationSchemesQuery,
				variables: {
					cloudId: tenantContext.cloudId,
				},
				options: {
					fetchPolicy: 'network-only' as const,
				},
			},
		},
	}),
});
